import { combineReducers } from "redux";
import { entitiesReducer } from "modules/ObjectStructures/services/Entities/reducer";

export const objectStructuresReducer = combineReducers({ entries: entitiesReducer });